/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Scope_LabelInputs */

const cs_ebr_scope_label = /** @type {(inputs: Ebr_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co importovat`)
};

const en_ebr_scope_label = /** @type {(inputs: Ebr_Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What to import`)
};

/**
* | output |
* | --- |
* | "What to import" |
*
* @param {Ebr_Scope_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_scope_label = /** @type {((inputs?: Ebr_Scope_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Scope_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_scope_label(inputs)
	return cs_ebr_scope_label(inputs)
});